import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import { $Elements, Durations, Events } from './constants';
import { disableBodyScroll, enableBodyScroll, lenis } from './helpers';
import { SmoothScroll } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Adhesion Modal ----------

	const $adhesionModal = $('#adhesion-modal');

	if($adhesionModal.length) {

		function openAdhesionModal() {
			$adhesionModal.addClass('show').attr('aria-modal', 'true');
			if(SmoothScroll && lenis) {
				lenis.stop();
			}
			document.documentElement.style.overflow = 'hidden';
		}

		function closeAdhesionModal() {
			$adhesionModal.removeClass('show').removeAttr('aria-modal');
			document.documentElement.style.overflow = '';
			if(SmoothScroll && lenis) {
				lenis.start();
			}
		}

		// Ouvrir la modal
		$(document).on('click', '[data-bs-target="#adhesion-modal"]', (e) => {
			e.preventDefault();
			openAdhesionModal();
		});

		// Fermer la modal (croix)
		$adhesionModal.on('click', '.btn-close', () => {
			closeAdhesionModal();
		});

		// Fermer la modal (clic sur le backdrop)
		$adhesionModal.on('click', (e) => {
			if($(e.target).is($adhesionModal)) {
				closeAdhesionModal();
			}
		});
	}


	// ---------- Slideshow ----------

	$('.carousel-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				observer: true,
				slidesPerView: 1.1,
				modules: [Navigation],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});
});
